export class MeasurementUnit {

  id: number;
  measurementInitials: string;
  description: string;
  quantity: number;
  indexPrice: number;
  defaultUnit: boolean;
  cartQuantity: number = 0;

  constructor(id?: number, measurementInitials?: string, description?: string, quantity?: number, indexPrice?: number, defaultUnit?: boolean) {
    if (id) {
      this.id = id;
      this.measurementInitials = measurementInitials;
      this.description = description;
      this.quantity = quantity;
      this.indexPrice = indexPrice;
      this.defaultUnit = defaultUnit;
    }
  };

  static fromJson(json: any): MeasurementUnit {
    var temp = new MeasurementUnit();
    temp.id = json.ID;
    temp.measurementInitials = json.MEASUREMENTUNIT;
    temp.description = json.DESCRIPTION;
    temp.quantity = json.QUANTITY;
    temp.indexPrice = json.INDEXPRICE;
    temp.defaultUnit = (json.DEFAULTUNIT === 'S');
    return temp;
  }

  static fromCart(json: any): MeasurementUnit {
    var temp = new MeasurementUnit();

    temp.measurementInitials = json.SELECTEDUNDMED;
    temp.quantity = (+json.SELECTEDUNDMEDQNT);
    temp.indexPrice = ((+json.LIQUIDVALUE / +json.SELECTEDQUANTITY) / json.PRICE) / temp.quantity;
    temp.description = json.SELECTEDUNDMEDDESC;
    temp.cartQuantity = json.SELECTEDQUANTITY;
    return temp;
  }
}
